import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

// Wired only on EU pages (where _analytics.html.erb defaulted GA4/Clarity to denied).
// On non-EU pages this file still loads (it's in the application bundle), but we never
// call CookieConsent.run unless the partial set `window.__cc_required` to true.

function applyGa4Consent(granted) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('consent', 'update', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: granted ? 'granted' : 'denied'
  });
  // GA4 keeps its native user_id slot (for cross-device stitching) but receives
  // the signed token as the value. signed_user_id is sent as a user-scoped
  // property (gtag('set', 'user_properties', …)) so it's pickable as a
  // User-scope custom dimension in GA4 reports. Both hold the same signed string.
  if (granted && window.__cc_signed_user_id) {
    window.gtag('set', { user_id: window.__cc_signed_user_id });
    window.gtag('set', 'user_properties', { signed_user_id: window.__cc_signed_user_id });
  }
}

// Inject the Clarity loader IIFE on demand — the partial omits it for EU users
// so the third-party request to clarity.ms doesn't happen before consent.
function loadClarity() {
  if (window.clarity || !window.__cc_clarity_id) return;
  (function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window,document,"clarity","script",window.__cc_clarity_id);
  if (window.__cc_rails_env) window.clarity('set', 'environment', window.__cc_rails_env);
}

function applyClarityConsent(granted) {
  if (granted) {
    loadClarity();
    // window.__cc_signed_user_id is the HMAC-signed user identifier set by the
    // partial. Reverse it via the "Reverse signed user id" Avo action.
    if (window.__cc_signed_user_id && typeof window.clarity === 'function') {
      window.clarity('identify', window.__cc_signed_user_id);
    }
  } else if (typeof window.clarity === 'function') {
    window.clarity('consent', false);
  }
}

let initialised = false;
function init() {
  if (initialised || !window.__cc_required) return;
  initialised = true;

  CookieConsent.run({
    guiOptions: {
      consentModal: { layout: 'box', position: 'bottom right', equalWeightButtons: true, flipButtons: false },
      preferencesModal: { layout: 'box', position: 'right', equalWeightButtons: true, flipButtons: false }
    },
    categories: {
      necessary: { enabled: true, readOnly: true },
      analytics: {
        autoClear: {
          cookies: [
            { name: /^_ga/ },
            { name: /^_gid$/ }
          ]
        },
        services: {
          ga4: {
            label: 'Google Analytics 4',
            onAccept: () => applyGa4Consent(true),
            onReject: () => applyGa4Consent(false)
          }
        }
      },
      recording: {
        autoClear: {
          cookies: [
            { name: /^_clck$/ },
            { name: /^_clsk$/ }
          ]
        },
        services: {
          clarity: {
            label: 'Microsoft Clarity (session recording)',
            onAccept: () => applyClarityConsent(true),
            onReject: () => applyClarityConsent(false)
          }
        }
      }
    },
    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'We value your privacy',
            description: 'FlyTabs uses cookies and similar technologies for analytics and to improve your experience. You can accept all, reject all, or pick what you allow.',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            showPreferencesBtn: 'Customize'
          },
          preferencesModal: {
            title: 'Privacy preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Save choices',
            closeIconLabel: 'Close',
            sections: [
              {
                title: 'Strictly necessary',
                description: 'Anonymous, cookieless analytics (Umami). Always on — required for the site to function.',
                linkedCategory: 'necessary'
              },
              {
                title: 'Analytics',
                description: 'Aggregate usage data via Google Analytics 4. Helps us understand which features are used.',
                linkedCategory: 'analytics'
              },
              {
                title: 'Session recording',
                description: 'Microsoft Clarity records anonymized session replays (mouse, scroll, page interactions) so we can spot UX issues. Clarity masks password fields and other fields it detects as sensitive; other text typed into forms may still be captured.',
                linkedCategory: 'recording'
              }
            ]
          }
        }
      }
    }
  });

  window.consent = {
    showPreferences: () => CookieConsent.showPreferences(),
    getConsent: () => CookieConsent.getUserPreferences()
  };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
